<template>
  <div class="csv-history">
    <v-card class="history-card" elevation="2">
      <v-card-text>
        <div class="history-header">
          <div class="history-title">
            <v-icon color="primary" class="mr-2">mdi-history</v-icon>
            <span>Historial de importaciones</span>
          </div>

          <v-btn v-if="loading" variant="text" size="small" loading disabled>
            Cargando...
          </v-btn>
        </div>

        <v-divider class="my-4"></v-divider>

        <div v-if="loading" class="text-center pa-6">
          <v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
          <p class="mt-3 text-grey">Cargando historial...</p>
        </div>

        <div v-else-if="imports.length === 0" class="text-center pa-6">
          <v-icon size="48" color="grey-lighten-1" class="mb-3">mdi-file-delimited-outline</v-icon>
          <p class="text-grey">No hay importaciones registradas aún.</p>
        </div>

        <div v-else class="history-table-wrapper">
          <table class="history-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Archivo</th>
                <th>Total</th>
                <th>Éxito</th>
                <th>Fallos</th>
                <th>Estado</th>
                <th>Duración</th>
                <th>Usuario</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="imp in imports" :key="imp.id">
                <td class="date-cell">{{ formatDate(imp.created_at) }}</td>
                <td class="filename-cell" :title="imp.original_filename">{{ imp.original_filename }}</td>
                <td class="text-center">{{ imp.total_rows }}</td>
                <td class="text-center success-text">{{ imp.successful_rows }}</td>
                <td class="text-center error-text">{{ imp.failed_rows }}</td>
                <td class="text-center">
                  <v-chip :color="getStatusColor(imp.status)" size="x-small" variant="tonal">
                    {{ getStatusLabel(imp.status) }}
                  </v-chip>
                </td>
                <td class="text-center">{{ formatDuration(imp.duration_ms) }}</td>
                <td>{{ imp.user?.name || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
defineProps({
  imports: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})

const formatDate = (dateStr) => {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  return date.toLocaleDateString('es-CO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

const formatDuration = (ms) => {
  if (!ms) return '-'
  if (ms < 1000) return ms + 'ms'
  return (ms / 1000).toFixed(1) + 's'
}

const getStatusColor = (status) => {
  const colors = {
    pending: 'grey',
    processing: 'info',
    completed: 'success',
    failed: 'error',
    partial: 'warning',
  }
  return colors[status] || 'grey'
}

const getStatusLabel = (status) => {
  const labels = {
    pending: 'Pendiente',
    processing: 'Procesando',
    completed: 'Completado',
    failed: 'Fallido',
    partial: 'Parcial',
  }
  return labels[status] || status
}
</script>

<style scoped>
.history-card {
  border-radius: 16px !important;
}

.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.history-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #0a192f;
  font-size: 1.1rem;
}

.history-table-wrapper {
  overflow-x: auto;
}

.history-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.history-table th {
  background: #f8fafc;
  color: #475569;
  font-weight: 600;
  padding: 10px 12px;
  text-align: left;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.history-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
}

.history-table tr:hover td {
  background: #f8fafc;
}

.date-cell {
  white-space: nowrap;
  color: #64748b;
}

.filename-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.success-text {
  color: #16a34a;
  font-weight: 600;
}

.error-text {
  color: #dc2626;
  font-weight: 600;
}
</style>
